var map = {
	"./blue.png": 2671,
	"./blueViolet.png": 9128,
	"./default.png": 9002,
	"./green.png": 7377,
	"./lightBlue.png": 2137,
	"./lightGreen.png": 8301,
	"./orange.png": 3668,
	"./pink.png": 3169,
	"./purple.png": 9926,
	"./red.png": 4275,
	"./yellow.png": 1821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;